import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { Subscription } from 'rxjs';
import { ScriptLoaderService } from 'app/services/script-loader.service';
import { config } from 'app/constants';
import { environment } from 'environments/environment';
import { datetimeFormat } from 'app/constants/date-time-format';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-global-payment-field',
  templateUrl: './global-payment-field.component.html',
  styleUrls: ['./global-payment-field.component.scss'],
  providers: [DialogService],
})
export class GlobalPaymentFieldComponent implements OnInit {
  dataServiceSubscription: Subscription;
  win: any;
  globalPaymentResponse: any = {};
  payment: any = {};
  orderVehicle: any = {};
  isProcessing = true;
  isSubmitting = false;
  company: any = {};
  redirect = config.redirectUrl.privacyAndSecurity;
  zip: string = '';
  billingAddress: any = {
    zip: '',
    state: '',
    city: '',
    street: '',
  };
  cardName: string = '';
  merchantId: string = '';
  apiKey: string = '';
  invoiceCode: string = '';
  usdPayment: string = '';
  globalPaymentErrorMsg: string = '';
  validCard: string = '';
  validExpiry: string = '';
  validCvv: string = '';
  credentials: any;
  isCountryCanada: boolean = false;
  cardForm: any;
  isDepositRequest: boolean = false;
  selectedPaymentMethod: any = {};
  globalPaymentMehod: any;
  activePaymentValue: any;
  paymentTime: string = '';
  token: string = '';
  createPaymentPayload: any = {};
  type: string = '';
  selectedInvoices: any;
  statementId: any;
  statement: any;

  // refund
  isRefund = false;
  companyLocalization: boolean = false;
  currentLang: string = 'en';

  constructor(
    public dataService: DataService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private scriptLoader: ScriptLoaderService,
    private dateService: DateService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const data = this.dConfig.data;

    if (data) {
      this.companyLocalization = data.localization;
      if (data.localization) {
        if (data.lang) {
          this.currentLang = data.lang.toLowerCase();
        }
      }
      this.translate.use(this.currentLang);
      this.payment = data.payment;
      this.merchantId = data.merchantId;
      this.apiKey = data.apiKey;
      this.token = data.token;
      this.credentials = data.credentials;
      // customer preview
      this.company = data.company;
      this.orderVehicle = data.orderVehicle;
      this.cardName = this.payment?.customer?.fullName || '';

      this.isDepositRequest = data.isDepositRequest;
      this.globalPaymentMehod = data.globalPaymentMehod;
      this.activePaymentValue = data.activePaymentValue;
      this.paymentTime = data.paymentTime;
      this.createPaymentPayload = data.createPaymentPayload;
      //  bulk payment data inputs
      this.type = data.type;
      this.selectedInvoices = data.selectedInvoices;
      this.statementId = data.statementId;
      this.statement = data.statement;

      if (this.payment?.customer?.customerId) {
        this.payment?.customer?.customerId?.address ? this.setCustomerAddress(this.payment.customer?.customerId?.address) : this.fetchCustomerAddressDetails(this.payment?.customer?.customerId);
      } else if (this.type === 'bulk' && this.payment?.customer) {
        this.setCustomerAddress(this.payment?.customer?.address);
      }
      // for deposit request
      if (this.isDepositRequest) {
        this.payment.collectedAmmount = this.payment?.depositRequest?.amount || 0;
      }
      if (!this.payment.collectedAmount) {
        this.payment.collectedAmount = data.isDepositRequest ? Number(this.payment?.depositRequest?.amount || 0).toFixed(2) : Number(this.payment.total.unpaid).toFixed(2);
      } else {
        this.payment.collectedAmount = data.isDepositRequest ? Number(this.payment?.depositRequest?.amount || 0).toFixed(2) : Number(this.payment.collectedAmount).toFixed(2);
      }
      this.usdPayment = this.payment.collectedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    this.getGlobalPayment().then(() => {
      this.setDataService();
    });

    if (data.isRefund) {
      this.isRefund = true;
    }
  }
  fetchCustomerAddressDetails(customerId) {
    try {
      let custId: any = this.helperService.deepCopy(customerId);
      if (typeof custId === 'object' && Object.keys(custId || {})?.length) {
        custId = customerId?._id;
      }
      this.httpService.getCustomer(custId).then(
        (res) => {
          this.setCustomerAddress(res.address);
        },
        (err) => {
          console.log('address not found');
        }
      );
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  setCustomerAddress(address) {
    this.billingAddress = {
      street: address?.addLine1 || '',
      zip: address?.zip || '',
      city: address?.city || '',
      state: address?.state || '',
    };
  }
  setDataService() {
    if (this.company) {
      // for customer preview
      if (this.company.address.country === 'Canada') {
        this.isCountryCanada = true;
      }
      return;
    }

    this.company = this.dataService.company;
    if (this.company.address.country === 'Canada') {
      this.isCountryCanada = true;
    }
  }

  closePaymentModal(isSuccess: boolean, data: any) {
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.ref.close({ isSuccess, data: data });
  }

  //  load globalPayment script
  async getGlobalPayment() {
    const res = await this.scriptLoader.loadScript('GlobalPayFieldsScript').then((r: any) => {
      if (!r) return;

      setTimeout(() => {
        const { GlobalPayments } = window as any;
        GlobalPayments.configure({
          // global pay @TODO need to change this
          'X-GP-Api-Key': this.credentials.payFieldsAPIKey,
          // 'X-GP-Api-Key': 'ivoeLOA9yfXOvsvIoDtRDEGNk2aNqCaY',
          'X-GP-Source-App-Name': this.credentials.appName,
          'X-GP-Environment': this.credentials.environment,
          enableAutoComplete: true,
        });

        const cardForm = GlobalPayments.ui.form({
          fields: {
            'card-number': { target: '#card-number', placeholder: '**** **** **** ****' },
            'card-expiration': { target: '#card-expiration', placeholder: 'MM / YY' },
            'card-cvv': { target: '#card-cvv', placeholder: '***' },
            submit: { target: '#submit', text: this.isRefund ? this.translate.instant('global-payment.refund-now') : this.translate.instant('global-payment.pay-now') },
          },

          styles: {
            'input[type=tel]': {
              padding: '8px 0',
              border: '0',
              'border-bottom': '1px solid #d7dada',
              'border-radius': '0',
            },
            'input[type=text]:focus-visible, input[type=tel]:focus-visible': {
              outline: 'none !important',
              'border-bottom-color': '#00c19d',
            },
            'button[type=button]': {
              'background-color': '#33ccaa',
              color: '#fff',
              height: '36px',
              'margin-left': '10px',
              border: 'none',
              'border-radius': '4px',
              cursor: 'pointer',
              'font-size': '14px',
              width: '100px !important',
              flex: '0 0 100px !important',
              display: 'flex',
              'justify-content': 'center',
              'align-items': 'center'
            },

            button: {
              color: 'white',
              background: '#33ccaa',
              border: 'none',
            },
            'input.invalid': {
              'border-color': '#ff8282',
            },
            'input.invalid:focus': {
              'border-color': '#d7dada',
            },
            'input.valid': {
              'border-color': '#d7dada',
            },
          },
        });

        cardForm.ready(() => {
          this.isProcessing = false;
        });
        // Event handlers
        cardForm.on('token-success', (rsp) => {
          if (this.validate()) {
            this.isSubmitting = true;
            if (rsp.temporary_token) {
              this.isSubmitting = false;
              if (this.token) {
                this.onCustomerPaymentScreen(rsp);
              } else if (this.type === 'bulk') {
                this.payment.paymentType = 'card';
                this.globalPayBulkPayment(rsp);
              } else if (this.isRefund) {
                this.handleRefund(rsp);
              } else {
                this.globalPaymentAPI(rsp);
              }
            }
          }
        });

        cardForm.on('token-error', (rsp) => {
          console.error('Error: ', rsp);
          this.currentLang !== 'en' ? this.globalPaymentErrorMsg = "Données d'entrée invalides." : this.globalPaymentErrorMsg = rsp.error.message;
        });

        cardForm.on('card-number-test', (rsp) => {
          // resp.valid will be “true” or “false”
        });

        // card number validation
        cardForm.on('card-number-test', (resp) => {
          this.validCard = resp.valid;
          toggleButton();
        });

        // expiry date validation
        cardForm.on('card-expiration-test', (resp) => {
          this.validExpiry = resp.valid;
          toggleButton();
        });

        // cvv validation
        cardForm.on('card-cvv-test', (resp) => {
          this.validCvv = resp.valid;
          toggleButton();
        });

        // apply stylings to submit button
        function toggleButton() {
          var valid = false;

          if (this.validCard && this.validExpiry && this.validCvv) {
            valid = true;
          }

          if (this.validCard && this.validExpiry) {
            valid = true;
          }

          cardForm.addStylesheet(
            !valid
              ? {
                button: {
                  color: ' #9c9c9c',
                  'pointer-events': 'none',
                  cursor: 'not-allowed',
                },
              }
              : {
                button: {
                  color: '#ffffff',
                  'pointer-events': 'auto',
                  cursor: 'pointer ',
                },
              }
          );
        }
      }, 2000);
    });
  }

  validate() {
    let formValid = true;
    if (!this.cardName) {
      this.currentLang === 'en' ? this.globalPaymentErrorMsg = 'Please provide card holder name' : this.globalPaymentErrorMsg = 'Veuillez fournir le nom du titulaire de la carte';
      // this.globalPaymentErrorMsg = 'Please provide card holder name';

      formValid = false;
    } else if (!this.billingAddress.zip) {
      // this.globalPaymentErrorMsg = 'Please provide zip code';
      this.currentLang === 'en' ? this.globalPaymentErrorMsg = 'Please provide zip code' : this.globalPaymentErrorMsg = 'Veuillez fournir le code postal';
      formValid = false;
    } else if (!this.billingAddress.street) {
      // this.globalPaymentErrorMsg = 'Please provide street address';
      this.currentLang === 'en' ? this.globalPaymentErrorMsg = 'Please provide street address' : this.globalPaymentErrorMsg = 'Veuillez fournir une adresse';
      formValid = false;
    }
    return formValid;
  }

  cardNameChange(data) {
    this.globalPaymentErrorMsg = '';
    this.cardName = data;
  }

  globalPaymentAPI(data) {
    try {
      this.isSubmitting = true;
      const payload = this.getPaymentPayload(data);
      this.httpService.createGlobalPayment(payload).then(
        (payment) => {
          this.closePaymentModal(true, payment);
        },
        (err) => {
          this.isSubmitting = false;
          this.isProcessing = false;
          this.globalPaymentErrorMsg = err;
        }
      );
    } catch (err) {
      // this.helperService.showToaster('error', err);
      this.isSubmitting = false;
      this.isProcessing = false;
      this.globalPaymentErrorMsg = err;
    }
  }

  globalPayBulkPayment(data) {
    try {
      this.isSubmitting = true;
      let payload = this.getPaymentPayload(data);
      payload = {
        payload,
        invoiceIds: Object.keys(this.selectedInvoices),
        statementId: this.statementId,
        statementName: this.statement.name,
        collectedAmount: this.payment.collectedAmount,
        globalPaymentResponse: this.globalPaymentResponse,
      };
      this.httpService.createBulkPayment(payload).then(
        (res: any) => {
          this.closePaymentModal(true, res);
        },
        (err) => {
          this.isSubmitting = false;
          this.isProcessing = false;
          if (err && err.msg) this.globalPaymentErrorMsg = err.msg;
          else this.globalPaymentErrorMsg = err;
        }
      );
    } catch (err) {
      // this.helperService.showToaster('error', err);
      this.isSubmitting = false;
      this.isProcessing = false;
      this.globalPaymentErrorMsg = err;
    }
  }

  onCardTypeSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  onCustomerPaymentScreen(rsp) {
    this.isSubmitting = true;
    this.globalPaymentResponse = rsp;
    this.globalPaymentResponse.cardHolderName = this.cardName;
    this.globalPaymentResponse.billingAddress = this.billingAddress;
    const payload = {
      ...this.createPaymentPayload,
      globalPaymentResponse: this.globalPaymentResponse,
      card4Digits: this.globalPaymentResponse?.card?.masked_card_number,
    };
    this.httpService
      .createPaymentCustomer(payload, this.token)
      .then((payment) => {
        this.closePaymentModal(true, payment);
      })
      .catch((e) => {
        this.helperService.showToaster('error', e);
        this.isSubmitting = false;
        this.isProcessing = false;
        this.globalPaymentErrorMsg = e;
      });
  }

  getPaymentPayload(data) {
    this.globalPaymentResponse = data;
    const card = data.card;
    //  setting payment method;
    if (data.card && data.temporary_token) {
      const [method] = this.globalPaymentMehod.filter(({ name }) => `${name}` === `${card.type}`);

      if (method) {
        this.payment.paymentMethod = card.type;
        this.onCardTypeSelect(method);
      }
    }
    this.payment.card4Digits = card.masked_card_number;
    this.payment.tempToken = data.temporary_token;
    this.payment.isOnline = true;
    this.payment.globalPaymentResponse = this.globalPaymentResponse;
    this.payment.globalPaymentResponse.cardHolderName = this.cardName;
    this.payment.globalPaymentResponse.billingAddress = this.billingAddress;

    this.payment.paymentProvider = 'globalPay';

    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.activePaymentValue,
    };
    this.payment.paymentType = this.activePaymentValue;
    if (!this.token) {
      const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
      const paymentDate = `${date} ${time}`;
      this.payment.paymentDate = paymentDate;
    }

    let payload = { ...this.payment };

    payload.currentOrderSession = !this.type ? this.helperService.getOrderSessions(this.payment.estimate.estimateId) : '';
    return payload;
  }

  updateValueChange(value, type) {
    this.billingAddress[type] = value;
    this.globalPaymentErrorMsg = '';
  }

  // refund API
  handleRefund(res) {
    this.globalPaymentResponse = {
      ...res,
      cardHolderName: this.cardName,
      billingAddress: this.billingAddress,
    };
    const refunObject = {
      paymentId: this.payment.id,

      payload: {
        globalPaymentResponse: this.globalPaymentResponse,
        type: this.payment.type,
        amount: this.payment.amount,
        refundDate: this.dateService.getCurrentDateTimeTz(new Date(this.payment.refundTime).getTime()),
        refundOnline: true,
      },
    };
    this.httpService
      .createRefund(refunObject)
      .then((res) => {
        this.closePaymentModal(true, res);
        this.helperService.showToaster('success', 'Refund successful');
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => {
        this.isSubmitting = false;
        // this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
      });
  }
}
